<script setup>
import { useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
  />
  <svg
    v-else
    v-once
    v-bind="attrs"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.2 2.5c0-.5.4-.9.9-.9h.7c.3 0 .5.1.7.4L7 6.8c.1.2.1.4 0 .5L4.5 12c-.2.3-.4.4-.7.4h-.7c-.5 0-.9-.4-.9-.9 0-.2.1-.4.2-.5l2.4-4c.1-.2.1-.4 0-.5L2.4 3c-.1-.2-.2-.3-.2-.5z"
      fill="#07D6A0"
    />
    <path
      d="M13.8 2.5c0-.5-.4-.9-.9-.9h-.7c-.3 0-.5.1-.7.4L9.8 4.8c-.1.2-.1.4.1.5l1 1c.2.2.4.2.6 0l2.1-2.1c.2-.2.2-.4.2-.7z"
      fill="#07D6A0"
    />
    <path
      d="M13.8 13.5c0 .5-.4.9-.9.9h-.7c-.3 0-.5-.1-.7-.4l-1.7-2.8c-.1-.2-.1-.4.1-.5l1-1c.2-.2.4-.2.6 0l2.1 2.1c.2.2.2.4.2.7z"
      fill="#0D4037"
    />
  </svg>
</template>
